import * as stylex from '@stylexjs/stylex'
import { type PropsWithChildren } from 'react'
import { Dialog, type DialogProps } from '../Dialog/Dialog'
import { Drawer, type DrawerProps } from '../Drawer/Drawer'
import { type ModalProps } from '../Modal/Modal'
import { useResponsive } from '../useResponsive/useResponsive'

const baseStyles = stylex.create({
  drawerPaper: {
    borderRadius: '8px 8px 0px 0px',
  },
})

export interface ResponsiveDialogProps extends Omit<ModalProps, 'xStyles' | 'title'> {
  /**
   * 自訂樣式覆寫，分為 dialog（桌面）與 drawer（行動裝置）兩組
   */
  xStyles?: {
    dialog?: DialogProps['xStyles']
    drawer?: DrawerProps['xStyles']
  }
  /**
   * 對話框最大寬度（僅桌面模式生效）
   */
  maxWidth?: DialogProps['maxWidth']
  /**
   * 對話框最大高度
   */
  maxHeight?: DialogProps['maxHeight']
  /**
   * 對話框最小高度
   */
  minHeight?: DialogProps['minHeight']
  /**
   * 對話框高度
   */
  height?: DialogProps['height']
  /**
   * 是否撐滿最大寬度（僅桌面模式生效）
   */
  fullWidth?: DialogProps['fullWidth']
}

/**
 * ResponsiveDialog 響應式對話框元件。
 * 桌面裝置顯示為 Dialog，行動裝置自動切換為底部 Drawer。
 */
export const ResponsiveDialog = (props: PropsWithChildren<ResponsiveDialogProps>) => {
  const { xStyles, maxWidth, maxHeight, height, minHeight, fullWidth, ...rest } = props
  const isMobile = useResponsive('mobile')

  if (isMobile) {
    const drawerXStyles: DrawerProps['xStyles'] = {
      base: {
        ...xStyles?.drawer?.base,
        paper: [baseStyles.drawerPaper, xStyles?.dialog?.paper, xStyles?.drawer?.base?.paper],
      },
      anchor: xStyles?.drawer?.anchor,
    }
    return <Drawer xStyles={drawerXStyles} direction="bottom" maxHeight={maxHeight} height={height} minHeight={minHeight} {...rest} />
  }
  return (
    <Dialog xStyles={xStyles?.dialog} maxWidth={maxWidth} maxHeight={maxHeight} height={height} minHeight={minHeight} fullWidth={fullWidth} {...rest} />
  )
}
